import React, { useRef, useEffect } from 'react';

interface MacOSWindowProps {
  children: React.ReactNode;
  title?: string;
}

export const MacOSWindow: React.FC<MacOSWindowProps> = ({ children, title = "Salt Palm" }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className="w-full h-full md:h-[90vh] md:w-[95vw] max-w-[1600px] flex flex-col bg-white/80 backdrop-blur-2xl md:rounded-2xl shadow-window overflow-hidden border border-white/40 transition-all duration-500 ease-in-out">
      {/* Title Bar */}
      <div className="h-10 bg-white/50 backdrop-blur-md border-b border-gray-200/50 flex items-center justify-between px-4 shrink-0 select-none z-50">
        <div className="flex space-x-2 group">
          <div className="w-3 h-3 rounded-full bg-[#FF5F56] border border-[#E0443E] shadow-sm group-hover:bg-[#FF5F56] flex items-center justify-center">
             <span className="opacity-0 group-hover:opacity-100 text-[8px] font-bold text-black/50">x</span>
          </div>
          <div className="w-3 h-3 rounded-full bg-[#FFBD2E] border border-[#DEA123] shadow-sm flex items-center justify-center">
            <span className="opacity-0 group-hover:opacity-100 text-[8px] font-bold text-black/50">-</span>
          </div>
          <div className="w-3 h-3 rounded-full bg-[#27C93F] border border-[#1AAB29] shadow-sm flex items-center justify-center">
            <span className="opacity-0 group-hover:opacity-100 text-[8px] font-bold text-black/50">+</span>
          </div>
        </div>
        
        <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center space-x-2 text-salt-charcoal/80 font-roboto text-xs font-medium tracking-wide">
          <span className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full bg-salt-teal/50"></span>
            {title}
          </span>
        </div>

        <div className="w-14"></div> {/* Spacer for symmetry */}
      </div>

      {/* Content Area */}
      <div 
        ref={contentRef}
        className="flex-1 overflow-y-auto overflow-x-hidden scroll-smooth relative"
        id="main-scroll-container"
      >
        {children}
      </div>
    </div>
  );
};